
/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ScaffoldSpecificationWebConsoleData {
  ScaffoldTypeId: string;
  ScaffoldTypeFurtherInformation: string;
  Description: string;
  DesignTypeId: string;
  DesignTypeFurtherInformation: string;
  LoadingLimitId: string;
  LoadingLimitFurtherInformation: string;
  MethodOfTyingId: string;
  MethodOfTyingFurtherInformation: string;
  MethodOfCladdingId: string;
  MethodOfCladdingFurtherInformation: string;
  ScaffoldingSystemId: string;
  HirePeriod: number;
  MaximumTonnage: number;
  StandingTonnage: number;
}


